<div khA11yDialog>
<button class="close-modal-icon" (click)="closeModal()" [khA11yLabel]="'A11Y_LABEL.CLOSE' | translate" type="button">
  <fa-icon khA11yHidden [icon]="['fas', 'times']"></fa-icon>
</button>

<div class="delete-account-modal-container" data-testid="delete-account-modal">
  <div khA11yLabelSource class="kh-heading-style kh-heading-sm mb-kh-2 d-flex flex-column align-items-center">
    {{ 'TEACHER_DELETE_ACCOUNT_MODAL.DELETE_YOUR_ACCOUNT' | translate }}
  </div>

  <div class="kh-body-md text-center mb-kh-3 rounded-sm">
    <kh-banner>
      <span [innerHTML]="'TEACHER_DELETE_ACCOUNT_MODAL.DELETE_CONFIRMATION' | translate"></span>
    </kh-banner>
  </div>

  <ng-container *ngIf="deleteAccountForm">
    <form [formGroup]="deleteAccountForm" name="deleteAccountForm" class="w-100" novalidate>
      <div class="kh-medium-text text-left mb-kh-2">
        {{ 'TEACHER_DELETE_ACCOUNT_MODAL.TYPE_TO_CONFIRM' | translate }}
      </div>

      <kh-common-input
        [formControlName]="deleteAccountFormFields.confirmation"
        [placeholder]="getPlaceholder()"
        testId="delete-field">
      </kh-common-input>
    </form>

    <div class="buttons-container">
      <button
        class="kh-tertiary-button kh-title-text"
        [disabled]="!isValid()"
        (click)="deleteAccount()"
        data-testid="delete-button">
        {{ 'TEACHER_DELETE_ACCOUNT_MODAL.DELETE_FOREVER' | translate }}
      </button>

      <div class="d-block w-kh-2 desktop-only"></div>

      <button
        class="kh-primary-button kh-title-text"
        (click)="closeModal()"
        data-testid="cancel-button">
        {{ 'TEACHER_DELETE_ACCOUNT_MODAL.NO_KEEP_MY_ACCOUNT' | translate }}
      </button>
    </div>
  </ng-container>
</div>
</div>